import { format, isSameDay } from 'date-fns';

import { getCulture } from 'utils/culture';

export const getLocaleAsync = (setterCb: (locale: Locale | undefined) => void) => {
  switch (getCulture()) {
    case 'es':
      import('date-fns/locale/es').then((esLocale) => setterCb(esLocale.default)).catch();
      return;
    case 'pt':
      import('date-fns/locale/pt').then((ptLocale) => setterCb(ptLocale.default)).catch();
      return;
    default:
      import('date-fns/locale/en-US').then((enLocale) => setterCb(enLocale.default)).catch();
  }
};

export const getFormattedRange = (
  locale: Locale | undefined,
  startDate: Date | undefined,
  endDate: Date | undefined,
  formatString = 'dd MMM yyyy',
) => {
  if (!startDate || !endDate) return '';

  if (isSameDay(new Date(startDate), new Date(endDate))) return format(new Date(startDate), formatString, { locale });
  return `${format(new Date(startDate), formatString, { locale })} - ${format(new Date(endDate), formatString, {
    locale,
  })}`;
};
